<template>
  <div
    class="visa-header"
    :class="{ 'bg-transparent': isNeedTransparent && navBgTransparent }"
  >
    <div class="container-md">
      <div class="brand-box">
        <a
          href="/"
          @click="clickLogo"
          :class="['index-logo', isNeedTransparent && navBgTransparent ? 'white' : 'blue']"
        ></a>
      </div>

      <div class="nav-box">
        <div
          class="nav-top-bar"
          :style="{ left: `${navTopBarLeft}px` }"
          v-if="navTopBarLeft"
        ></div>
          <div class="nav-list-left nav-list">
            <div
              class="nav-item"
              @click="goIndex"
              :class="{ active: $route.path === '/' }"
            >
              首页
            </div>
            <div
              class="nav-item country-item"
              :class="{ active: $route.path.indexOf('countries') > -1 }"
              @mouseenter="toggleCountryBox(1)"
              @mouseleave="toggleCountryBox(2)"
            >
              <div class="nav-item-body" @click="goCountries">
                签证办理
                <span
                  class="down-icon"
                  :style="{
                    background:
                      isNeedTransparent && navBgTransparent
                        ? 'url(https://o.666visa.cn/static/ssqpeer/homepage/icon-down-white.png) no-repeat center/contain'
                        : '',
                  }"
                ></span>
              </div>
              <transition name="el-fade-in-linear">
                <nav-country-list
                  class="nav-country-list"
                  :is-show-point="true"
                  v-show="shouldCountryBoxShow"
                  @on-hide-self="shouldCountryBoxShow = false"
                  :page-from="pageFrom"
                ></nav-country-list>
              </transition>
            </div>
            
            <div
              class="nav-item"
              @click="goChatVisa"
              :class="{ active: $route.path.indexOf('chat-visa') > -1 }"
            >
              签问
              <!-- <base-popover-for-new-function
                ref="chatvisaPopoverEl"
                position="bottom-left"
                theme="white"
                title="新功能上线"
                desc="签问 AI，随时随地为您答疑解惑～"
                storage-key="showed-header-chatvisa-popover"
                @confirm="goChatVisa"
              >
                签问
              </base-popover-for-new-function> -->
            </div>
            <div
              class="nav-item "
              v-if="!is_palmyou"
              @click="goInsurances"
              :class="{ active: $route.path.indexOf('insurances') > -1 }"
            >
              保险商城
            </div>
            <div
              class="nav-item help-item"
              @click="goVisaKnowledge"
              :class="{
                active:
                  $route.path.indexOf('guide') > -1 ||
                  $route.path.indexOf('visa-article') > -1 ||
                  $route.path.indexOf('latest-news') > -1 ||
                  $route.path.indexOf('visa-open-class') > -1 ||
                  $route.path.indexOf('case-analysis') > -1 ||
                  $route.path.indexOf('academy') > -1,
              }"
            >
              签证知识
            </div>
            <div
              class="nav-item"
              @click="goVisaApi"
              :class="{ active: $route.path.indexOf('visa-api') > -1 }"
            >
              签证API
            </div>
            <div
              class="nav-item"
              v-if="User.isLogin()"
              :class="{ active: $route.path.indexOf('order') > -1 }"
            >
              <div class="nav-item-body" @click="goOrders">我的订单</div>
            </div>
          </div>
          <div class="nav-list-right nav-list">
            <div
              class="nav-item country-item"
              @mouseenter="toggleLanguageBox(1)"
              @mouseleave="toggleLanguageBox(2)"
            >
            <div class="nav-item-body">
                简体中文
                <span
                  class="down-icon"
                  :style="{
                    background:
                      isNeedTransparent && navBgTransparent
                        ? 'url(https://o.666visa.cn/static/ssqpeer/homepage/icon-down-white.png) no-repeat center/contain'
                        : '',
                  }"
                ></span>
              </div>
              <transition name="el-fade-in-linear">
                <div class="nav-language-box" v-show="shouldLanguageBoxShow">
                  <div class="nav-language-box-content">
                    <div class="nav-language-box-item active">简体中文</div>
                    <div class="nav-language-box-item"><a href="https://www.visageniusglobal.com/business/">English</a></div>
                  </div> 
                </div>
              </transition>
            </div>
            <div
              class="nav-item nav-login-wrap"
              :class="{ active: $route.path.indexOf('user') > -1 }"
            >
              <div class="not-login f-s-0" v-if="!User.isLogin()">
                <span
                  @click="goLogin"
                  class="s-btn"
                  :class="{
                    'btn-blue is-plain': !(isNeedTransparent && navBgTransparent),
                  }"
                  >登录</span
                >
                <span @click="goRegist" class="s-btn btn-blue m-l-20 register-btn"
                  >免费注册</span
                >
              </div>
              <div
                class="already-login"
                v-if="User.isLogin()"
                @mouseenter="userMenu = true"
                @mouseleave="userMenu = false"
              >
                <div class="nav-item-body" @click="goAccount">
                  <span>个人中心</span>
                  <span
                    v-if="!is_palmyou"
                    class="down-icon"
                    :style="{
                      background:
                        isNeedTransparent && navBgTransparent
                          ? 'url(https://o.666visa.cn/static/ssqpeer/homepage/icon-down-white.png) no-repeat center/contain'
                          : '',
                    }"
                  ></span>
                </div>
                <!-- 用户信息浮窗 -->
                <transition name="el-fade-in-linear">
                  <user-hover
                    v-show="userMenu && !is_palmyou"
                    class="user-hover"
                  ></user-hover>
                </transition>
              </div>
            </div>
            <div class="nav-item" v-if="User.isLogin()">
              <div class="msg-box" @click="goMessage">
                <a>
                  <img
                    class="img"
                    :src="`https://o.666visa.cn/static/ssqpeer/homepage/icon-msg-${
                      isNeedTransparent && navBgTransparent ? 'white' : 'black'
                    }.png`"
                  />
                </a>
                <div class="msg-num" v-if="msgCount">
                  {{ msgCount > 99 ? "99+" : msgCount }}
                </div>
              </div>
            </div>
          </div>
          
          
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';
import User from '../../libs/user';
import userHover from '../common/user-hover';
import navCountryList from './nav-country-list';
import sensorService from '../../services/sensor-service';
import BasePopoverForNewFunction from './popover/base-popover-for-new-function.vue';

export default {
  name: 'peer-header',
  props: ['msgCount'],
  components: {
    userHover,
    navCountryList,
    BasePopoverForNewFunction,
  },
  data() {
    return {
      userMenu: false,
      User,
      shouldCountryBoxShow: false,
      navTopBarLeft: 0,
      navBgTransparent: true,
      shouldLanguageBoxShow: false, // 语言切换
      pageFrom: '目的地页',
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
    isNeedTransparent() {
      const routerList = ['/', '/about-us', '/visa-api'];
      return routerList.includes(this.$route.path);
    },
    peer() {
      return User.peer || {};
    },
    currentUserName() {
      const name = this.User.is_admin ? this.peer.peer_name : this.User.name;
      if (name) {
        return name.length > 5 ? `${name.substring(0, 5)}...` : name;
      }
      return '';
    },
    is_palmyou() {
      return this.userInfo.is_palmyou;
    },
  },
  created() {
    this.handlePageScroll();
  },
  watch: {
    $route() {
      this.userMenu = false;
      this.countNavTopBarLeft();
    },
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    goto(url) {
      this.$router.push({
        path: url,
      });
    },
    handlePageScroll() {
      window.addEventListener('scroll', () => {
        const bodyScrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (bodyScrollTop > 10) {
          this.navBgTransparent = false;
        } else {
          this.navBgTransparent = true;
        }
      });
    },
    // 计算导航栏顶部条的left值
    countNavTopBarLeft() {
      this.$nextTick(() => {
        const el = document.querySelector('.nav-item.active');
        this.navTopBarLeft = el ? el.offsetLeft + (el.offsetWidth - 26) / 2 : 0;
      });
    },
    trackHeatMap(e) {
      sensorsdata.quick('trackHeatMap', e.target);
    },
    toggleCountryBox(action) {
      if (action === 2) {
        this.shouldCountryBoxShow = false;
      } else if (action === 1) {
        this.shouldCountryBoxShow = true;
      }
    },
    // 语言环境切换
    toggleLanguageBox(action) {
      if (action === 2) {
        this.shouldLanguageBoxShow = false;
      } else if (action === 1) {
        this.shouldLanguageBoxShow = true;
      }
    },

    // 这样写是增加神策热力图追踪
    goLogin(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.SHOW_LOGIN_BOX();
    },

    // 这样写是增加神策热力图追踪
    goRegist(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.SHOW_LOGIN_BOX({ page: 5 });
    },

    // 到订单界面
    goOrders(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ name: 'orders' });
    },
    // 到消息中心
    goMessage(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ name: 'message' });
    },
    // 签证API
    goVisaApi(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ path: '/visa-api' });
    },
    gotoAboutUs(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ path: '/about-us' });
    },
    goCountries(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      // 商详神策埋点page_from字段
      const query = sensorService.getPageFrom(this.pageFrom);
      this.$router.push({ path: '/countries', query });
    },
    clickLogo() {
      if (this.$route.path === '/') {
        this.$router.go(0);
      }
    },
    // 到首页
    goIndex(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (this.$route.path === '/') {
        this.$router.go(0);
      } else {
        this.$router.push({ path: '/' });
      }
    },
    // 到旅游保险
    goInsurances(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({
        name: 'insurances',
        query: { from: 'nav_insurance' },
      });
    },

    // 签证知识
    goVisaKnowledge(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ name: 'academy' });
    },

    // 到我的账户
    goAccount(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (User.is_palmyou) {
        if (User.is_admin) {
          this.$router.push({ name: 'staff' });
        } else {
          this.$router.push({ name: 'address' });
        }
      } else {
        this.$router.push({ name: 'balance' });
      }
    },
    goChatVisa(e) {
      if (e && e.target) sensorsdata.quick('trackHeatMap', e.target);
      if (this.$refs.chatvisaPopoverEl) this.$refs.chatvisaPopoverEl.onKnow();
      this.$router.push({ name: 'ChatVisa',
        query: {
          page_from: '导航栏',
        },
      });
    },
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable.less";

.visa-header {
  box-sizing: border-box;
  position: fixed;
  background-color: #fff;
  top: 0;
  left: 0;
  width: 100%;
  height: 68px;
  z-index: 100;
  transition: all 0.3s;
  color: #2f333d;
  border-bottom: 1px solid #e9eef2;
  &.bg-transparent {
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);
    .nav-top-bar {
      background: #fff !important;
    }
    .nav-item {
      &.active {
        color: #fff !important;
      }
      &:hover {
        color: #fff !important;
      }
    }
  }
  .container-md {
    height: 100%;
    display: flex;
    .brand-box {
      height: 100%;
      // flex-grow: 1;
      // font-size: 0;
      display: flex;
      align-items: center;
      margin-right: 40px;
      .index-logo {
        width: 120px;
        height: 38px;
        &.white {
          background: url(../../assets/imgs/common/header-logo-white.png) no-repeat center / 100% 100%;
        }
        &.blue {
          background: url(../../assets/imgs/common/header-logo-blue.png) no-repeat center / 100% 100%;
        }
      }
    }
    .nav-box {
      // flex-shrink: 0;
      flex: 1;
      height: 100%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      position: relative;
      .nav-top-bar {
        position: absolute;
        left: 0;
        top: 0;
        width: 26px;
        height: 3px;
        background: @new-blue;
        border-radius: 0px 0px 100px 100px;
        transition: left 0.2s;
      }
      .nav-list {
        height: 100%;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        .nav-item {
          font-size: 16px;
          margin-right: 40px;
          height: 100%;
          display: flex;
          align-items: center;
          position: relative;
          cursor: pointer;
          &.is-new {
            &::after {
              content: "";
              width: 31px;
              height: 16px;
              background: url(../../assets/imgs/insurance-new/icon-new.png)
                no-repeat center / 100% 100%;
              position: absolute;
              right: -24px;
              top: 18px;
            }
          }
          .popover-box{
            width: 240px;
            padding: 12px;
          }
          .nav-item-body {
            height: 100%;
            display: flex;
            align-items: center;
            cursor: pointer;
            position: relative;
          }
          .down-icon {
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-left: 4px;
            background: url(https://o.666visa.cn/static/ssqpeer/homepage/icon-down-black.png)
              no-repeat;
            background-size: 100% 100%;
            transform: translateY(-2px);
          }
          &:last-child {
            margin-right: 0;
          }
          &.active {
            color: @new-blue;
            font-weight: 600;
            .down-icon {
              background: url(https://o.666visa.cn/static/ssqpeer/homepage/icon-down-blue.png)
                no-repeat;
              background-size: 100% 100%;
            }
          }
          &:hover {
            color: @new-blue;
            .down-icon {
              background: url(https://o.666visa.cn/static/ssqpeer/homepage/icon-down-blue.png)
                no-repeat;
              background-size: 100% 100%;
            }
          }
          &.country-item {
            .nav-country-list {
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              margin-top: 1px;
            }
          }
          &.nav-login-wrap {
            .not-login {
              height: 100%;
              cursor: default;
              display: flex;
              align-items: center;
              .s-btn {
                width: 98px;
              }
            }
            .already-login {
              height: 100%;
              display: flex;
              align-items: center;
            }
            .user-hover {
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
            }
            .register-btn {
              position: relative;
              &::after {
                content: '';
                display: inline-block;
                width: 85px;
                height: 30px;
                position: absolute;
                background: url(../../assets/imgs/homepage/first-order-discount.png) no-repeat;
                background-size: 100% 100%;
                top: -14px;
                right: -48px;
              } 
            }
          }
          .msg-box {
            width: 18px;
            height: 18px;
            position: relative;
            cursor: pointer;
            .img {
              width: 18px;
              height: 18px;
            }
            .msg-num {
              text-align: center;
              min-width: 17px;
              position: absolute;
              left: 100%;
              bottom: 100%;
              transform: translate(-8px, 8px);
              padding: 2px;
              background: #ff6464;
              color: #fff;
              font-size: 12px;
              border-radius: 2px;
            }
          }
        }

        .help-item {
          &:hover .help-hover-box {
            display: flex;
            opacity: 1;
            visibility: visible;
          }
          .help-hover-box {
            * {
              line-height: normal;
            }
            visibility: hidden;
            font-weight: normal;
            border: 1px solid #e9eef2;
            display: flex;
            opacity: 0;
            padding: 20px;
            width: 508px;
            background-color: #ffffff;
            box-shadow: 0px 8px 12px 0px rgba(47, 51, 61, 0.06);
            border-radius: 4px;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            transition: all 0.3s;
            cursor: default;
            &::after {
              content: "";
              position: absolute;
              top: -8px;
              left: 50%;
              box-shadow: border-box;
              width: 15px;
              height: 15px;
              background: #fff;
              transform: translateX(-50%) rotate(45deg);
              transform-origin: center center;
              border-top: 1px solid #e9eef2;
              border-left: 1px solid #e9eef2;
              border-radius: 2px 0 0 0;
              z-index: 1;
            }
            ul.help-items {
              list-style-type: none;
              display: flex;
              width: 100%;
              justify-content: space-between;
              li {
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;
                img {
                  width: 32px;
                  height: 32px;
                }
                .item-name {
                  font-size: 14px;
                  line-height: 14px;
                  color: #333;
                  margin-top: 15px;
                }
                .item-desc {
                  font-size: 12px;
                  line-height: 12px;
                  color: #aaa;
                  margin-top: 10px;
                }
                &:hover {
                  img {
                    animation: "help-item-animation" 1.5s linear infinite;
                  }
                  .item-name {
                    color: #599fff;
                  }
                  .item-desc {
                    color: #599fff;
                  }
                }
              }
            }
          }
        }
      }
      .nav-dropdown-box{
        display: flex;
        align-items: center;
        height: 40px;
        align-self: center;
        .el-dropdown-link{
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
  .nav-language-box{
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 1px;
    box-shadow: 0px 8px 12px 0px rgba(57, 61, 70, 0.06);
    .nav-language-box-content{
      padding: 10px 0;
      background: #fff;
      border-radius: 4px;
    }
    .nav-language-box-item{
      padding: 16px 20px;
      color: #2F333D;
      font-size: 14px;
      line-height: 20px;
      background-color: #fff;
      white-space:nowrap;
      a{
        color: #2F333D;
      }
      &.active{
        color: #599FFF;
      }
      &:hover{
        background-color: #F3F6F9;
      }
    }
    &::after{
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      box-shadow: border-box;
      width: 15px;
      height: 15px;
      background: #fff;
      transform: translateX(-50%) rotate(45deg);
      transform-origin: center center;
      border-top: 1px solid #E9EEF2;
      border-left: 1px solid #E9EEF2;
      border-radius: 2px 0 0 0;
      z-index: 1;
    }
  }
}
.s-nav-language-dropmenu{
  .el-dropdown-menu__item{
    color: #2F333D;
  }
  a{
    color: inherit;
  }
  .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #F3F6F9;
    color: #2F333D;
  }
}
@keyframes help-item-animation {
  0% {
    transform: translateY(0) scale(1.1);
  }
  25% {
    transform: translateY(-1px) scale(1.1);
  }
  75% {
    transform: translateY(1px) scale(1.1);
  }
  100% {
    transform: translateY(0) scale(1.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue